module.exports = __webpack_public_path__ + "img/addtohtop.dcaede3b.png";